import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'note-to-hrsa',
  templateUrl: './note-to-hrsa.component.html',
  styleUrls: ['./note-to-hrsa.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NoteToHrsaComponent {}
